
import React from "react";


function Merch() {
    return (
      <div id="cal">
        <div className="calapes">
            <h2>$CALAPES Merch Coming Soon!</h2>
        </div>
      </div>
      
    );
  }
  
  export default Merch;